<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.Prompt')"
    width="400px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div style="display: flex;flex-direction: column; text-align: center">
      <span style="line-height: 40px;">{{ resultMsg }}</span>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" style="margin-right: 30px;" no="1" @click="continueImporting()">{{ $t('SeaExport.ContinueImporting') }}</el-button>
      <el-button type="primary" style="margin-right: 30px;" no="2" @click="downloadResultLog()">{{ $t('SeaExport.DownloadResultLog') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'

export default {
  name: 'ImportResult',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    result: { type: Object, required: true }
  },
  data() {
    return {
      storageURL: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    resultMsg: {
      get() {
        return StrUtils.substitute(this.$t('SeaExport.SuccessItemFailedItem'), this.result.successNum, this.result.failNum)
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
    },
    continueImporting() {
      this.$emit('continueImporting')
    },
    downloadResultLog() {
      const fileId = this.result.fileId
      if (fileId === '') {
        this.$message.success(this.$t('SeaExport.NotFindFile'))
        return
      }
      const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
      window.open(url)
    }
  }
}
</script>

<style scoped>

</style>
